export class Unregister{
  devId:string;
  licensee:string;
  name:string;
  requestedTime:string;
  manufactor:string;
  requestedUserName:string;
}
